import { buildMediaUrl } from '../Services/mediaUrl';
import ImageGallery from './ImageGallery';
import MessageArchiveDownload, { hasArchivableAttachments } from './MessageArchiveDownload';

export const FileRender = ({ message }) => {
  const files = message.files || [message];

  const downloadFile = (file, download = false) => {
    const fileSource = file.base64 || file.url || buildMediaUrl(file, 'files', download);
    if (!fileSource) return;

    const link = document.createElement('a');
    link.href = fileSource;
    link.download = file.fileName || 'downloaded-file';
    link.target = '_blank';
    link.rel = 'noopener noreferrer';

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const downloadAll = () => {
    files.forEach((file) => downloadFile(file, true));
  };

  const isPdf = files[0]?.fileName?.toLowerCase().endsWith('.pdf');
  const useArchive = hasArchivableAttachments({ files });

  return (
    <>
      {useArchive && <MessageArchiveDownload files={files} />}
      {files.length > 0 && !useArchive && (
        <div className="file-download-link" onClick={downloadAll}></div>
      )}
      {isPdf && message.images?.length > 0 && <ImageGallery message={message} />}
      {files.map((file, idx) => {
        const ext = file.fileName?.split('.').pop()?.toUpperCase() || 'FILE';

        return (
          <div
            key={idx}
            className={`file-wrapper file-${ext.toLowerCase()} clickable`}
            onClick={() => downloadFile(file)}
          >
            <div className="file-info">
              <div className="file-name">{file.fileName}</div>
              <div className="file-creds">
                <span className="file-ext">{ext}</span>
                <span>Document</span>
                <span className="file-separator"></span>
                <span className="file-size">{file.size}</span>
                <span>MB</span>
              </div>
            </div>
            <div className="file-icon"></div>
          </div>
        );
      })}
    </>
  );
};
